import { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";

import SuspenseLoader from "src/components/SuspenseLoader";

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Containers = Loader(lazy(() => import("src/content/containers")));

const containersRoutes = [
  {
    path: "/",
    element: (
      <>
        <Helmet>
          <title> Konteynerler </title>
        </Helmet>
        <Containers />
      </>
    ),
  },
];

export default containersRoutes;
